<template>
  <div>
    <ImpressaoModal
      header="Receita Médica"
      :ref="refs"
      size="lg"
      :pageSelect="true"
      @acao="imprimirReceita"
      idModal="receitamodalimpressao"
    >
      <div class="modal-body">
        <HTMLReport
          v-if="dados && paciente && medico && unidade"
          :pageSize="pageSize"
          id="imprimir-receita"
          v-show="false"
        >
          <br />
          <span>
            Nome:
            <strong>{{ paciente.st_nome }}</strong>
          </span>
          <br />
          
          <h4><i class="fas fa-prescription"></i></h4>

          <ul class="list-group">
            <li class="list-group-item m-1 pb-2 border-0" v-for="(item, id) in dados.items" :key="id"
              style="page-break-inside: avoid;">
              <div>
                <strong>{{ item.item.st_medicamento }}</strong>
              </div>
              <div>
                <span v-if="item.in_quantidade">
                  {{ item.in_quantidade }}
                  <span v-if="item.apresentacao">
                    {{ item.apresentacao.st_apresentacao }}
                  </span>
                </span>
                <span v-if="item.st_posologia">
                  {{ item.st_posologia }}
                </span>
              </div>
              <div>
                {{ item.st_observacoes }}
              </div>
            </li>
          </ul>
          <br />
          <br />
          <br />
          <span>{{ assinaturaReport() }}</span>
          <template v-slot:rodape>
            <rodape-medico :medico="medico" />
          </template>
        </HTMLReport>
      </div>
    </ImpressaoModal>
  </div>
</template>

<script>
import HTMLReport from "../HTMLReport";
import * as moment from "moment";
import ImpressaoModal from "../shared/ModalImpressao";
import RodapeMedico from "./RodapeMedico.vue";

export default {
  data() {
    return {
      unidade: null,
      pageSize: "", 
      idModal: "",
      dados: null
    };
  },
  
  props: ["paciente", "medico"],
  
  components: { 
    HTMLReport, 
    ImpressaoModal,
    RodapeMedico 
  },

  methods: {
    assinaturaReport() {
      return (
        ( ( this.unidade.endereco && this.unidade.endereco.cidade ) ? this.unidade.endereco.cidade.st_cidade : "" ) +
        ",  " +
        ( 
          this.dados.fl_exibir_data !== null && !this.dados.fl_exibir_data ? '_____/______/_________' : 
            ( 
              this.dados.dt_referencia ? moment(this.dados.dt_referencia, 'YYYY-MM-DD').format("DD [de] MMMM [de] YYYY") : 
              moment().format("DD [de] MMMM [de] YYYY") 
            )
        )
      );
    },
    abrirModal(dadosIniciais) {
      this.dados = dadosIniciais;
      this.$nextTick(() => {
        this.$refs[this.refs].abrirModalImpressao();
      });
    },
    imprimirReceita(dados) {
      let configPrint;
      this.dados = dados;
      this.pageSize = this.$util.getCookie('page-size');

      if (this.pageSize == "A4") {
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
            "https://api.klingo.app/css/estiloa4.css"
          ]
        };
      } else if (this.pageSize === "A5") {
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
            "https://api.klingo.app/css/estiloa5.css"
          ]
        };
      } else { 
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
          ]
        };
      }

      this.$nextTick(() => {
        this.$htmlToPaper("imprimir-receita", configPrint, () =>
          console.log("printed...")
        );
      });
    }
  },
  computed: {
    refs() {
      return this.$util.gerarRandomString(9, "modalreceita");
    }
  },
  mounted() {
    this.unidade = this.$store.state.unidade;
  }
};
</script>

<style></style>
